import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import {
  renderField,
  required,
  renderTextArea,
  number,
  renderPass,
  renderToggle,
  renderSelectField,
  renderPassTextArea,
} from "../../../../utils/formValidations.js";
import { Field, reduxForm, formValueSelector, getFormValues, getFormInitialValues } from "redux-form";
import { withRouter } from "react-router-dom";
import {withTranslation} from "react-i18next";
import { Button, FormFooter, Groups, FormField } from "../../../../components/Form"

class KubevirtProviderFormTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentProvider: {},
    };
    this.submitApi = this.submitApi.bind(this);
    this.cancelButton = this.cancelButton.bind(this);
    this.updateBoot = this.updateBoot.bind(this);
    this.updateNetwork = this.updateNetwork.bind(this);
  }

  componentDidMount() {

    let newValues = {
      ...this.props?.initial_values,
      ...this.props?.current_provider
    }
    this.props.initialize({
      ...newValues
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
      this.props.initialize({
        vm_provider_config_name: nextProps.current_provider.vm_provider_config_name,
        vm_provider_name: nextProps.current_provider.vm_provider_name,
        max_instances: nextProps.current_provider.max_instances,

        kube_host: nextProps.current_provider.kube_host,
        kube_ssl_cert: nextProps.current_provider.kube_ssl_cert,
        kube_api_token: nextProps.current_provider.kube_api_token,

        vm_namespace: nextProps.current_provider.vm_namespace,
        vm_public_ssh_key: nextProps.current_provider.vm_public_ssh_key,

        cores: nextProps.current_provider.cores,
        memory: nextProps.current_provider.memory,
        disk_source: nextProps.current_provider.disk_source,
        disk_size: nextProps.current_provider.disk_size,

        interface_type: nextProps.current_provider.interface_type,
        network_name: nextProps.current_provider.network_name,
        network_type: nextProps.current_provider.network_type,

        enable_tpm: nextProps.current_provider.enable_tpm,
        enable_efi_boot: nextProps.current_provider.enable_efi_boot,
        enable_secure_boot: nextProps.current_provider.enable_secure_boot,

        startup_script: nextProps.current_provider.startup_script,
        config_override: nextProps.current_provider.config_override,
      });
    }
  }

  cancelButton() {
    this.props.cancel_button(userData)
  }

  submitApi(userData) {
    userData.vm_provider_name = "kubevirt"
    this.props.submit_api(userData)
  }

  updateBoot(event) {
    if (event.target.checked === false) {
      this.props.change('enable_secure_boot', false)
    }
  }

  updateNetwork(event) {
    const { change } = this.props;
    if (event.target.value === 'multus') {
      change('interface_type', 'bridge')
    } else {
      change('interface_type', this.props?.initial_values.interface_type)
    }
  }

  render() {
    const { handleSubmit, t, KubevirtProviderFormValues } = this.props;

    return (
      <Groups noPadding section="providers" onSubmit={handleSubmit(this.submitApi)}>
        <FormField label="Name">
          <Field type="text"
            name="vm_provider_config_name"
            id="vm_provider_config_name"
            placeholder={t("providers.Example-KubeVirt-Config")}
            component={renderField}
            validate={required} required
          />
        </FormField>

          <Field type="number"
            name="max_instances"
            id="max_instances"
            placeholder={t("10")}
            help="kb-24-kubevirt-1"
            component={renderField}
            validate={number} required
          />

          <Field type="text"
            name="kube_host"
            id="kube_host"
            placeholder="https://kubevirt.example.com"
            help="kb-24-kubevirt-2"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="kube_ssl_cert"
            id="kube_ssl_cert"
            placeholder=""
            help="kb-24-kubevirt-3"
            component={renderPassTextArea}
          />

          <Field type="text"
            name="kube_api_token"
            id="kube_api_token"
            placeholder=""
            help="kb-24-kubevirt-4"
            component={renderPass}
          />

          <Field type="text"
            name="vm_namespace"
            id="vm_namespace"
            placeholder=""
            help="kb-24-kubevirt-5"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="vm_public_ssh_key"
            id="vm_public_ssh_key"
            placeholder="ssh-rsa AAAAAAA...."
            help="kb-24-kubevirt-6"
            component={renderField}
          />

          <Field type="number"
            name="cores"
            id="cores"
            placeholder="2"
            help="kb-24-kubevirt-7"
            component={renderField}
            validate={number} required
          />
  
          <Field type="number"
            name="memory"
            id="memory"
            placeholder="2"
            help="kb-24-kubevirt-8"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="disk_source"
            id="disk_source"
            placeholder="examplePVCname"
            help="kb-24-kubevirt-9"
            component={renderField}
            validate={required} required
          />

          <Field type="number"
            name="disk_size"
            id="disk_size"
            placeholder="20"
            help="kb-24-kubevirt-10"
            component={renderField}
            validate={required} required
          />

          <Field type="select"
            name="network_type"
            id="network_type"
            help="kb-24-kubevirt-13"
            component={renderSelectField}
            onChange={this.updateNetwork}
            validate={required} required>
              <option value="">{t("providers.Select")}</option>
              <option value="pod">pod</option>
              <option value="multus">multus</option>
          </Field>

          <Field type="select"
            name="interface_type"
            id="interface_type"
            help="kb-24-kubevirt-12"
            component={renderSelectField}
            disabled={KubevirtProviderFormValues && KubevirtProviderFormValues.network_type === "multus"}
            validate={required} required>
              {KubevirtProviderFormValues && KubevirtProviderFormValues.network_type !== "multus" && <option value="">{t("providers.Select")}</option>}
              {KubevirtProviderFormValues && KubevirtProviderFormValues.network_type !== "multus" && <option value="masquerade">masquerade</option>}
              <option value="bridge">bridge</option>
          </Field>

          {KubevirtProviderFormValues && KubevirtProviderFormValues.network_type === 'multus' &&
          <Field type="text"
            name="network_name"
            id="network_name"
            help="kb-24-kubevirt-13"
            component={renderField}
          />
          }

          <Field type="text"
            name="startup_script"
            id="startup_script"
            placeholder="#!/bin/bash&#10;..."
            help="kb-24-kubevirt-14"
            component={renderTextArea}
          />

          <Field type="text"
            name="config_override"
            id="config_override"
            placeholder="apiVersion: kubevirt.io/v1&#10;kind: VirtualMachine&#10;..."
            help="kb-24-kubevirt-15"
            component={renderTextArea}
          />

          <Field type="checkbox"
            name="enable_tpm"
            id="enable_tpm"
            help="kb-24-kubevirt-16"
            checked={this.props.enable_tpm && this.props.current_provider.enable_tpm}
            component={renderToggle}
          />

          <Field type="checkbox"
            name="enable_efi_boot"
            id="enable_efi_boot"
            help="kb-24-kubevirt-17"
            checked={this.props.enable_efi_boot && this.props.current_provider.enable_efi_boot}
            onChange={this.updateBoot}
            component={renderToggle}
          />

          {KubevirtProviderFormValues && KubevirtProviderFormValues.enable_efi_boot &&
          <Field type="checkbox"
            name="enable_secure_boot"
            id="enable_secure_boot"
            help="kb-24-kubevirt-18"
            checked={this.props.enable_secure_boot && this.props.current_provider.enable_secure_boot}
            component={renderToggle}
          />
          }

        <FormFooter
          cancelButton={<button className="cancel-button tw-bg-transparent" type="cancel" onClick={() => this.props.cancel_button()}> {this.props.wizard ? t("buttons.Previous") : t("buttons.Cancel")}</button>}
          saveButton={<Button id="save-kubevirt-vm" icon="save" type="submit" section="buttons" name={!this.props.wizard ? 'Submit' : this.props.stepCount && this.props.stepCount > 2 ? t("buttons.Next") : t("buttons.Finish")} />}
        />

      </Groups>
    );
  }
}

KubevirtProviderFormTemplate.propTypes = {
  current_provider: Proptypes.object,
  submit_api: Proptypes.func.isRequired,
  handleSubmit: Proptypes.func,
  cancel_button: Proptypes.func,
  KubevirtProviderFormValues: Proptypes.object,
};

let KubevirtProviderFormWithRouter = withRouter(KubevirtProviderFormTemplate);

let KubevirtProviderForm = connect(state => 
  ({
    vm_provider_configs: state.vm_provider.vm_provider_configs,
    KubevirtProviderFormValues: state.form && state.form.VmProviderForm && state.form.VmProviderForm.values ? state.form.VmProviderForm.values : null,
  }), dispatch =>({}))(KubevirtProviderFormWithRouter);

const KubevirtProviderFormTranslated = withTranslation('common')(KubevirtProviderForm)

export default reduxForm({
  form: "VmProviderForm",
})(KubevirtProviderFormTranslated);
